import mapboxgl from 'mapbox-gl';
import { useLayoutEffect, useRef, useState } from 'react';

const useMapboxMap = <T extends HTMLDivElement>(): [React.RefObject<T> | undefined, mapboxgl.Map | undefined] => {
    const containerRef = useRef<T>(null);
    const [map, setMap] = useState<mapboxgl.Map>();

    mapboxgl.accessToken = 'pk.eyJ1IjoibWV0b2NlYW4iLCJhIjoia1hXZjVfSSJ9.rQPq6XLE0VhVPtcD9Cfw6A';

    useLayoutEffect(() => {
        if (!containerRef.current) {
            return;
        }

        const mapboxMap = new mapboxgl.Map({
            container: containerRef.current,
            style: 'mapbox://styles/mapbox/cj44mfrt20f082snokim4ungi',
            center: [180, 0],
            zoom: 0,
        });

        let isMounted = true;

        const onMapLoad = () => {
            isMounted && setMap(mapboxMap);
        };

        mapboxMap.on('load', onMapLoad);

        return () => {
            isMounted = false;

            mapboxMap.off('load', onMapLoad);
        };
    }, [containerRef]);

    return [containerRef, map];
};

export default useMapboxMap;
